import React from 'react';
import { useTranslation } from 'react-i18next';
import { Quote } from 'lucide-react';
import { useScrollAnimation } from 'hooks/useScrollAnimation';

export const Testimonials = () => {
    const { t } = useTranslation();
    const { ref, isVisible } = useScrollAnimation({ threshold: 0.2 });

    const testimonials = [
        { key: 'review1', initial: 'A' },
        { key: 'review2', initial: 'S' },
        { key: 'review3', initial: 'J' },
    ];

    return (
        <section id="testimonials" className="py-20 bg-white overflow-hidden">
            <div className="container mx-auto px-4" ref={ref}>
                <div className={`text-center mb-16 transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
                    <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
                        {t('testimonials.title')}
                    </h2>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {testimonials.map((testimonial, index) => (
                        <div
                            key={testimonial.key}
                            className={`bg-cyan-50 p-8 rounded-2xl relative transition-all duration-700 ease-out hover:shadow-xl hover:-translate-y-2 group ${index === 2 ? 'md:col-span-2 lg:col-span-1' : ''} ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                            style={{ transitionDelay: isVisible ? `${0.2 + index * 0.2}s` : '0s' }}
                        >
                            <Quote className="absolute top-4 right-4 text-primary/20 w-12 h-12 group-hover:text-primary/40 group-hover:scale-110 transition-all duration-300" />
                            <p className="text-gray-700 mb-6 italic relative z-10 leading-relaxed">
                                "{t(`testimonials.${testimonial.key}.text`)}"
                            </p>
                            <div className="flex items-center gap-4">
                                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center text-primary font-bold shadow-sm text-lg group-hover:scale-110 group-hover:shadow-md transition-all duration-300">
                                    {testimonial.initial}
                                </div>
                                <div>
                                    <p className="font-bold text-gray-900">{t(`testimonials.${testimonial.key}.author`)}</p>
                                    <p className="text-sm text-gray-500">{t(`testimonials.${testimonial.key}.role`)}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
